import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'src/store';
import { PlansUtils } from 'src/utils';

export const useCustomerSubscription = () => {
  const stripeCustomer = useSelector(
    (state: RootState) => state.user.data?.stripeCustomer,
  );
  const stripeSubscriptions = useSelector(
    (state: RootState) => state.user.data?.stripeSubscriptions,
  );
  const customerPaymentMethods = useSelector(
    (state: RootState) => state.user.data?.stripePaymentMethods,
  );

  // `stripeSubscriptions` can briefly be undefined while `stripeCustomer`
  // (which includes an embedded subscriptions list) is already available.
  // Prefer explicit subscriptions from user data, then fall back to customer data
  // so plan-dependent UI (e.g. upgrade/trial banners) does not flap.
  const allSubscriptions = React.useMemo(
    () => stripeSubscriptions ?? stripeCustomer?.subscriptions?.data,
    [stripeSubscriptions, stripeCustomer],
  );

  // filter out trial and incomplete subscriptions
  const customerSubscriptions = React.useMemo(
    () => PlansUtils.activeSubscriptions(allSubscriptions),

    [allSubscriptions],
  );

  const customerSubscription = React.useMemo(
    () =>
      customerSubscriptions && customerSubscriptions.length > 0
        ? customerSubscriptions.at(0)
        : undefined,
    [customerSubscriptions],
  );

  return {
    stripeCustomer,
    allSubscriptions, // holds all subscriptions trial and paid (having all statuses)
    customerSubscriptions: customerSubscriptions || [],
    customerSubscription,
    customerPaymentMethods,
  };
};
